module.exports = __webpack_public_path__ + "img/clip.0c21f4d2.svg";